/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOlympics = createReactComponent("olympics", "IconOlympics", [
  ["path", { d: "M6 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M18 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M9 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }],
  ["path", { d: "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-4" }]
]);

export { IconOlympics as default };
//# sourceMappingURL=IconOlympics.js.map
